<template lang="pug">
.introduction
  sys-bar(:backable="true" ref="sysBar")
  .content(ref="content")
    router-view
    //transition(name="slide")
      router-view


</template>
<script>
import SysBar from '@/components/SysBar'
import { mapMutations, mapState } from 'vuex'
import Intro from '@/views/Introduction/Intro'
export default {
  name: 'Introduction',
  components: { Intro, SysBar },
  props: {},
  data() {
    return {}
  },
  watch: {
    $route(val) {
      console.log(val)
      if (val.path === '/introduction/intro') {
        if (this.router.back != '/reservation/res2') this.setRouterBack('/')
      }
    },
  },
  computed: {
    ...mapState('app', ['router']),
  },
  methods: {
    ...mapMutations('app', ['setRouterBack']),
  },
  mounted() {
    this.$refs.content.style.height =
      window.innerHeight -
      this.$refs.sysBar.$el.getBoundingClientRect().height +
      'px'
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.introduction
  .content
    position: relative
.slide-enter-active, .slide-leave-active
  transition: all 0.5s
.slide-enter, .slide-leave-to
  transform: translateX(100%)
</style>
